module.exports = __webpack_public_path__ + "img/P150T_weapon_121.e975b84a.png";